module.exports = __webpack_public_path__ + "img/home-where-bitcoin.473d31e9.png";